import { Popover, PopoverTrigger, PopoverContent } from "@heroui/react";

export const CustomPopover = ({
  open,
  setOpen,
  trigger,
  children,
  placement = "bottom",
}) => {
  return (
    <Popover
      placement={placement}
      offset={4}
      classNames={{
        base: "shadow-md !rounded-md !bg-white",
        content: "!p-0 !rounded-md !bg-white",
      }}
      isOpen={open}
      onOpenChange={setOpen}
    >
      <PopoverTrigger className="cursor-pointer">
        <button type="button" className="cursor-pointer" aria-expanded={open}>
          {trigger}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-full">{children}</PopoverContent>
    </Popover>
  );
};
